import { Grid, styled } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import React, { Children } from "react";

interface MxDetailSmallCardProps {
  children: any;
  id?: string;
  title: string;
  maxHeight?: number;
}
const MxDetailSmallCard = (props: MxDetailSmallCardProps) => {
  return (
    <Grid
      id={props.id}
      container
      item
      xs={12}
      borderRadius={1}
      bgcolor="background.paper"
      rowGap={2}
      p={0.5}
    >
      <Grid item xs={12} px={3.5} pt={2}>
        <MxTypography color="primary.main" fontWeight={600} variant="subtitle1">
          {props.title}
        </MxTypography>
      </Grid>
      <ContainMain item xs={12} px={3} pb={2} maxHeight={props.maxHeight}>
        {props.children}
      </ContainMain>
    </Grid>
  );
};

export default MxDetailSmallCard;
const ContainMain = styled(Grid)(({ theme }) => ({
  overflowY: "auto"
  // maxHeight: 200
}));
